import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * LineChartTooltip: this tooltip is the basic line chart tooltip.
 */
export class LineChartTooltip {
	public static getFormatter(): Function {
		return function (): string {
			let out =
				'<div style="white-space:normal;">' +
				'<h4 class="title">' +
				Highcharts.dateFormat('%a, %b %e, %Y', this.x) +
				'</h4>' +
				'<table style="table-layout:fixed; width: 160px;">';
			this.points.forEach(point => {
				const seriesColor = point.series.color;
				out +=
					'<tr><td style="color: ' +
					StringUtil.escapeHtml(seriesColor) +
					';">' +
					StringUtil.escapeHtmlWithChartLineBreaks(StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)) +
					'</td>' +
					'<td style="text-align: right;">' +
					'$' +
					Highcharts.numberFormat(point.y, 2, '.', ',') +
					'</td>' +
					'</tr>';
			});
			out += '</table></div>';
			return out;
		};
	}
}
